export const PRICING_BUSINESS_RATE_COLUMNS_WITH_RATES = [
  'requestingPlatform_Name',
  'clientSiiSalesSection_Value',
  'debtorSiiSalesSection_Value',
  'monthlyRate',
  'defaultRate',
];

export const PRICING_BUSINESS_RATE_COLUMNS_WITH_SPREAD = [
  'requestingPlatform_Name',
  'clientSiiSalesSection_Value',
  'debtorSiiSalesSection_Value',
  'spread',
];
